  <div class="body__option container-body-options show" [ngClass]="{
    'inputs-white': colorInputs === 'WHITE'
  }">
    <div class="row" style="padding-bottom: 10px;">
      <div class="col-12 col-md-4" *ngFor="let control of [asFormControl(newEquipmentForm.controls.brand)]">
        <div class="form" [ngClass]="control.validator?.length ? 'form--required' : ''">
          <label for="" class="label">
            {{ emptyTitles ? '-' : 'Marca equipo' }} <app-tooltip text="Fabricante del equipo."></app-tooltip>
          </label>
          <input type="text" placeholder="Ingresar" [formControl]="control">
        </div>
      </div>
      <div class="col-12 col-md-4" *ngFor="let control of [asFormControl(newEquipmentForm.controls.model)]">
        <div class="form" [ngClass]="control.validator?.length ? 'form--required' : ''">
          <label for="" class="label">
            {{ emptyTitles ? '-' : 'Modelo equipo' }} <app-tooltip text="Numero o codigo del modelo identificador del equipo">
            </app-tooltip>
          </label>
          <input type="text" placeholder="Ingresar" [formControl]="control">
        </div>
      </div>
    </div>
    <div class="row body__row--two" style="padding-bottom: 10px;">
      <div class="col-12 col-md-4 body__col">
        <div class="form form--required">
          <label for="" class="label astObliGatoriEquip">
            {{ emptyTitles ? '-' : 'Tipo de licencia' }}
            <app-tooltip></app-tooltip>
          </label>
          <div class="form__check mb-2" *ngFor="let item of licenseTypes; index as i;">
            <input type="checkbox" id="opt1{{item.description}}_{{item.id}}_{{id}}"
              [formControl]="asFormControl(getCheckControls(item.id!, 'LICENSE_TYPE').active)"
              [attr.disabled]="!getCheckControls(item.id, 'LICENSE_TYPE').isEnabled.value ? true : null"
            >
            <label
              for="opt1{{item.description}}_{{item.id}}_{{id}}"
              [ngClass]="{'no-pointer-events': !getCheckControls(item.id, 'LICENSE_TYPE').isEnabled.value  || iAmTheLastOfMyKind(item.id!, 'LICENSE_TYPE')}"
            >
              <div
                class="fakebox"
                [ngClass]="{
                  'dark-grey-bg': !getCheckControls(item.id!, 'LICENSE_TYPE').isEnabled.value  || iAmTheLastOfMyKind(item.id!, 'LICENSE_TYPE'),
                  'no-pointer-events': !getCheckControls(item.id, 'LICENSE_TYPE').isEnabled.value  || iAmTheLastOfMyKind(item.id!, 'LICENSE_TYPE')
                }"
              ></div>
              {{ item.description }}
            </label>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 body__col">
        <div class="form form--required">
          <label for="" class="label astObliGatoriEquipForZones">
            {{ emptyTitles ? '-' : 'Zonas de conducción' }}
            <app-tooltip></app-tooltip>
          </label>
          <div class="d-flex">
            <div class="mr-5">
              <ng-container *ngFor="let item of conductionZones | slice: 0 : conductionZonesSlice ;index as i">
                <div class="form__check mb-2" [ngClass]="{'global-unmount': getCheckControls(item.id, 'ZONES').isHidden.value}">
                  <input
                    type="checkbox"
                    id="opt2{{item.description}}_{{item.id}}_{{id}}"
                    [formControl]="asFormControl(getCheckControls(item.id!, 'ZONES').active)"
                    [attr.disabled]="!getCheckControls(item.id).isEnabled.value  || iAmTheLastOfMyKind(item.id!, 'ZONES')? true : null"
                  >
                  <label
                    for="opt2{{item.description}}_{{item.id}}_{{id}}"
                    [ngClass]="{'no-pointer-events': !getCheckControls(item.id).isEnabled.value  || iAmTheLastOfMyKind(item.id!, 'ZONES')}"
                  >
                    <div
                      class="fakebox"
                      [ngClass]="{
                        'dark-grey-bg': !getCheckControls(item.id!, 'ZONES').isEnabled.value  || iAmTheLastOfMyKind(item.id!, 'ZONES'),
                        'no-pointer-events': !getCheckControls(item.id).isEnabled.value  || iAmTheLastOfMyKind(item.id!, 'ZONES')
                      }"
                    ></div>
                    {{ item.description }}
                  </label>
                </div>
              </ng-container>
            </div>
            <div>
              <ng-container *ngFor="let item of conductionZones | slice: conductionZonesSlice : conductionZones.length ;index as i">
              <div
                class="form__check mb-2"
              >
                <input
                  type="checkbox"
                  id="opt2{{item.description}}_{{item.id}}_{{id}}"
                  [formControl]="asFormControl(getCheckControls(item.id!, 'ZONES').active)"
                  [attr.disabled]="!getCheckControls(item.id).isEnabled.value  || iAmTheLastOfMyKind(item.id!, 'ZONES')? true : null"
                >
                <label
                  for="opt2{{item.description}}_{{item.id}}_{{id}}"
                  [ngClass]="{'no-pointer-events': !getCheckControls(item.id).isEnabled.value  || iAmTheLastOfMyKind(item.id!, 'ZONES')}"
                >
                  <div
                    class="fakebox"
                    [ngClass]="{
                      'dark-grey-bg': !getCheckControls(item.id!, 'ZONES').isEnabled.value  || iAmTheLastOfMyKind(item.id!, 'ZONES'),
                      'no-pointer-events': !getCheckControls(item.id).isEnabled.value  || iAmTheLastOfMyKind(item.id!, 'ZONES')
                    }"
                  ></div>
                  {{ item.description }}
                </label>
              </div>
            </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row body__row--two" style="padding-bottom: 10px;">
      <div class="col-12 col-md-4 body__col">
        <button type="button" class="btn btn--primary px-5" [disabled]="newEquipmentForm.valid ? false : true"
      (click)="onSaveChanges()"> {{ emptyTitles ? '-' : 'Guardar cambios' }}</button>
      </div>
      <div class="col-12 col-md-4 body__col align-end">
        <button type="button" class="btn button--outlined px-5 me-5" [disabled]="newEquipmentForm.valid ? false : true"
      (click)="onDiscardChanges()"> {{ emptyTitles ? '-' : 'Volver' }}</button>
      </div>
    </div>
  </div>
  <!-- </div> -->
